import { connect } from "react-redux";
import {
  createOrUpdateWorkerShiftRequest,
  recurringMessageModal,
  setPendingShiftRequestApproval,
  clearPendingShiftRequestApproval,
} from "store/actions/rostering.actions";
import {
  getCreateOrUpdateWorkerShiftError,
  getCreateOrUpdateWorkerShiftLoader,
  getWorkerAndParticipantOptions,
  getRecurringMessage,
  showRecurringModal,
} from "store/selector/rostering.selector";
import WorkerShiftDuplicate from "./WorkerShiftDuplicate";
import {
  getSPParticipantsListRequest,
  workerProfileDetailsFetchRequest,
} from "store/actions/sp.actions";
import {
  getSelectedWorker,
  getSpRosteringSetting,
  getSpRosteringSettingLoader,
  getWorkerProfileDetailLoader,
} from "store/selector/sp.selector";

const mapDispatchToProps = {
  createOrUpdateWorkerShiftRequest,
  recurringMessageModal,
  workerProfileDetailsFetchRequest,
  getParticipantList: getSPParticipantsListRequest,
  setPendingShiftRequestApproval,
  clearPendingShiftRequestApproval,
};

const mapStateToProps = (state) => {
  const workerAndParticipantOptions = getWorkerAndParticipantOptions(state);
  const createOrUpdateWorkerShiftLoader =
    getCreateOrUpdateWorkerShiftLoader(state);
  const createOrUpdateWorkerShiftError =
    getCreateOrUpdateWorkerShiftError(state);
  const recurringMessages = getRecurringMessage(state);
  const isRecurringModal = showRecurringModal(state);
  const workerProfileDetails = getSelectedWorker(state);
  const getWorkerProfileLoader = getWorkerProfileDetailLoader(state);
  const spRosteringSettingLoader = getSpRosteringSettingLoader(state);
  const spRosteringSetting = getSpRosteringSetting(state);

  return {
    workerAndParticipantOptions,
    createOrUpdateWorkerShiftLoader,
    createOrUpdateWorkerShiftError,
    recurringMessages,
    isRecurringModal,
    workerProfileDetails,
    getWorkerProfileLoader,
    spRosteringSetting,
    spRosteringSettingLoader,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkerShiftDuplicate);
